module.exports = __webpack_public_path__ + "media/images/admin/dropzone/eye-32c66418b0aef9e27be271cc74480ba6.png";